import React, { Component } from 'react';
import styled from 'styled-components';

const HoldMessageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;

  padding-top: 20px 
  padding-left: 20px;
  padding-right: 20px;

  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: normal;
  color: #787871;`;

class HoldMessage extends Component {
  render() {
    const userName = this.props.activity.from.name;
    return (
      <HoldMessageContainer>
        Conversation with {userName} is temporarily on hold
      </HoldMessageContainer>
    );
  }
}

export default HoldMessage;



// WEBPACK FOOTER //
// ./src/components/MetaMessages/HoldMessage.js